import { render, staticRenderFns } from "./concepts-grid.vue?vue&type=template&id=b4e4e65a&"
import script from "./concepts-grid.ts?vue&type=script&lang=ts&"
export * from "./concepts-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports